import React, { useState, useEffect } from 'react';
import { CopyOutlined as ContentCopyIcon,  } from '@ant-design/icons';
import Swal from 'sweetalert2';
import copy from "copy-to-clipboard";  
import { 
    Button,
    Grid,
    IconButton,
    LinearProgress,
    MenuItem,
    Paper,
    TextField,
   } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { SnackbarProvider, useSnackbar } from 'notistack';
import {       
        Dns as DnsIcon,
   } from '@material-ui/icons';
import  FacebookCircularProgress  from '../../Elementos/FacebookCircularProgress';
import { 
    Button as ButtonAntd,
    Tooltip as TooltipAntd,
    Switch as SwitchAntd,
    Progress
} from 'antd';
import { LockOutlined } from '@ant-design/icons';
import GenerarPass from '../../helpers/GenerarPass';
import ConvertArrToJson from '../helpers/ConvertArrToJson';

const CambiarZonaBack = ({ 
    arrAps, 
    arrZonas, 
    data, 
    dataCliente, 
    getPlanes,
    isSelectedZona, 
    zonaSelected, 
    zonaSelectedObject, 
})=>{ 
    const [ getDatos, setDatos ] = useState({
        UserPPOE:'',
        PassPPOE:''
    } );
    //const { authTokens } = useAuth(); 
    const { enqueueSnackbar } = useSnackbar();
    const [ zonaSelectedNew, setZonaSelectedNew ] = useState('');
    const [ zonaSelectedObjectNew, setZonaSelectedObjectNew ] = useState({});
    const [ PlanesNew, setPlanesNew ] = useState([]);
    const [ isZonaPPOE, setZonaPPOE ] = useState(false);
    const [ valPlanNew, setValPlanNew ] = useState(0);
    const [ isNewFibraOptica, setNewFibraOptica ] = useState(false);
    const [ selectPlanNew, setSelectPlanNew ] = useState('');
    const [ selectPlanNewComercial, setSelectPlanNewComercial ] = useState('');
    const [ isContinuo1, setContinuo1 ] = useState(false);
    const [ isContinuo2, setContinuo2 ] = useState(false);
    const [ isSavingClient, setSavingClient ] = useState(false);
    const [ getArrIp, setArrIp ] = useState([]);
    const [ getIpNew, setIpNew ] = useState('');
    const [ getRedNew, setRedNew ] = useState('');
    const [ isSelectedZonaNew, setSelectedZonaNew ] = useState(false);
    const [ isSelectRed, setSelectRed ] = useState(false);
    const [ isContinuoRed, setContinuoRed ] = useState(false);
    const [ isContinuoZona, setContinuoZona ] = useState(false);
    const [ isProcessRed, setProcessRed ] = useState(false);
    const [ getPorcentaje, setPorcentaje ] = useState(0);
    const [ getStatus, setStatus ] = useState('normal');
    const [ isOldIp, setOldIp ] = useState(false);
    const [ idOldIp, setIdOldIp ] = useState('');

    useEffect(()=>{
        if(isContinuo1){
            setPorcentaje(33);
            handleDeleteServicio();
            setContinuo1(false);
        }

    },[isContinuo1]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isContinuo2){
            setPorcentaje(66);
            handleAddServicio();
            setContinuo2(false);
        }

    },[isContinuo2]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isContinuoRed){
            handleFilterIp();
            setContinuoRed(false)
        }

    },[isContinuoRed]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isContinuoZona){
            setContinuoZona(false);
            const arrFil =  arrZonas.find(value=> value.Zona.toString() === zonaSelectedNew.toString());
            setZonaSelectedObjectNew(arrFil);
            setPlanesNew(arrFil.planLocal ? arrFil.Planes : getPlanes);     
            if(arrFil.ppoeList)setZonaPPOE(true);
            if(arrFil.isFibraOptica)setNewFibraOptica(true);
            if(arrFil.Subnet.length === 1){
                handleRedNew(arrFil.Subnet[0].Red);
                setSelectedZonaNew(true); 
            }else{
                setSelectedZonaNew(true);   
            }
        }

    },[isContinuoZona]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClearZonaNueva = ()=>{
        setZonaSelectedNew('');
        setZonaSelectedObjectNew({});
        setPlanesNew([]);
        setSelectPlanNew('');
        setZonaPPOE(false);
        setNewFibraOptica(false);
        setValPlanNew(0);   
        setIpNew('');
        setSelectedZonaNew(false); 
        setRedNew('');
        setArrIp([]);
        setSelectRed(false);
        setContinuoRed(false);
        setDatos({
            UserPPOE:'',
            PassPPOE:''
        });
        setPorcentaje(0);
        setStatus('normal');
    };

    const handleSelectZonaNueva = (valZ)=>{
        if(isSelectRed){
            setZonaSelectedNew(valZ);
            setRedNew('');
            setArrIp([]);
            setSelectRed(false);
            setContinuoRed(false);
            setContinuoZona(true);   
            if(zonaSelectedObject.ppoeList){
                setDatos({
                    UserPPOE:data.UserPPOE,
                    PassPPOE:data.PassPPOE
                });
            }    
        }else{
            setZonaSelectedNew(valZ);
            setContinuoZona(true); 
            if(zonaSelectedObject.ppoeList){
                setDatos({
                    UserPPOE:data.UserPPOE,
                    PassPPOE:data.PassPPOE
                });
            }  
        }

        
    };

    const copyToClipBoardUser = ()=>{  
        copy(data.idForMikrotik) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleSelectPlanNew = (valP)=>{ 
        const planes = zonaSelectedObjectNew.planLocal ?  zonaSelectedObjectNew.Planes : getPlanes;
        const valPlan_ = planes.find(el=> el.PlanComercial === valP);
        setSelectPlanNew(valPlan_.Plan); 
        setSelectPlanNewComercial(valP);
        setValPlanNew(valPlan_.Valor);    
     };

    const handleClearPlanNew = ()=>{ 
        setSelectPlanNew('');
        setSelectPlanNewComercial('');
        setValPlanNew(0);   
    };

    const handleDatos = (e) =>{ setDatos({...getDatos, [e.target.id]: e.target.value}) };

    const handleAddressIp = ({target})=>{ 
        const elementoIp = getArrIp.filter(el=> el.IP.toString() === target.value.toString())[0];
        if(isOldIp){
            const planes = zonaSelectedObjectNew.planLocal ?  zonaSelectedObjectNew.Planes : getPlanes;
            const valPlan_ = planes.find(el=> el.Plan === elementoIp.Plan);
            setSelectPlanNew(elementoIp.Plan); 
            setSelectPlanNewComercial(valPlan_.PlanComercial);
            setValPlanNew(valPlan_.Valor);    
            setIpNew(target.value);
            setIdOldIp(elementoIp.idFromMikrotik);
            setDatos({...getDatos,
                UserPPOE:elementoIp.idForMikrotik,
                PassPPOE:elementoIp.PassWord
            });
        }else{
            if(elementoIp.Status === 'DISPONIBLE' ){
                setIpNew(target.value);
            }else{
                Swal.fire({
                    title:'IP NO DISPONIBLE',
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
            } 
        }
       
    };

    const handleFilterIp = ()=>{
        setProcessRed(true);
        const arrfillZona = arrAps.filter(el=>el.Zona === zonaSelectedNew);
        let arrAp = [];
        if(arrfillZona.length > 0) arrAp = arrfillZona.map(el=>el.IP);
        if(zonaSelectedObjectNew.simpleQueue){
            fetch('/api/getIpsSimpleQueue',{
                method:'POST',
                body: JSON.stringify({InfoZona:zonaSelectedObjectNew}),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then((result) =>{
                let arrComp = [];
                let rangeZone = getRedNew.split('.');
                const arr4 = [];
                const arrComplete4 = [];
                for(const x in result){
                    for(const y in result[x]){
                        if(result[x][y].field === 'target'){ 
                            if(result[x][y].value.split('/').length === 2){
                                let val_0 = result[x][y].value.split('/')[0].toString();
                                let val = val_0.split('.');
                                let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                                if(getRedNew.toString() === range.toString()) arr4.push(val_0);
                            }
                        }
                    };
                };
                for(let i = 2; i < 255; i++ ){
                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                    if(arr4.includes(number)){
                        const objeto = {};
                        for(const x in result){
                            for(const y in result[x]){
                                if(result[x][y].field === 'target'){ 
                                    if(result[x][y].value.split('/').length === 2){
                                        let val_0 = result[x][y].value.split('/')[0].toString();
                                        if(val_0 === number){ 
                                            objeto.idForMikrotik = result[x][1].value ;
                                        }
                                    }

                                }
                            };
                        };
                        objeto.Status = 'NO DISPONIBLE';
                        objeto.IP = number;
                        arrComplete4.push(objeto);                                           
                    }else{
                        if(arrAp.includes(number)){
                            const objeto = {};
                            for(const y in arrfillZona){
                                if(arrfillZona[y].IP === number) objeto.idForMikrotik =  arrfillZona[y].SSID;
                            };
                            objeto.Status = 'AP';
                            objeto.IP = number;
                            arrComplete4.push(objeto);
                        }else{
                            const objeto = {};
                            objeto.Status = 'DISPONIBLE';
                            objeto.IP = number;
                            arrComplete4.push(objeto);
                        }
                        
                    }
                }
                arrComp = arrComp.concat(arrComplete4);         
                setArrIp(arrComp);      
                setProcessRed(false);             
            });
        }else if(zonaSelectedObjectNew.queueTree){
            fetch('/api/getIpsQueueTree',{
                method:'POST',
                body: JSON.stringify({InfoZona:zonaSelectedObjectNew}),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then((result) =>{
                let arrComp = [];
                let rangeZone = getRedNew.split('.');
                const arr4 = [];
                const arrComplete4 = [];
                for(const x in result){
                    for(const y in result[x]){
                        if(result[x][y].field === 'address'){ 
                            let val = result[x][y].value.split('.');
                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                            if(getRedNew.toString() === range.toString()) arr4.push(result[x][y].value);
                        }
                    };
                };
                for(let i = 2; i < 255; i++ ){
                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                    if(arr4.includes(number)){
                        const objeto = {};
                        for(const x in result){
                            for(const y in result[x]){
                                if(result[x][y].field === 'address'){ 
                                    if(result[x][y].value === number) {
                                        objeto.idForMikrotik = result[x][6] ? result[x][6].value : null;
                                        objeto.Plan = result[x][1].value;
                                        objeto.idFromMikrotik = result[x][0].value;
                                    }
                                }
                            };
                        };
                        objeto.IP = number;
                        objeto.Status = 'NO DISPONIBLE';
                        arrComplete4.push(objeto);
                    }else{
                        if(arrAp.includes(number)){
                            const objeto = {};
                            for(const y in arrfillZona){
                                if(arrfillZona[y].IP === number) objeto.idForMikrotik =  arrfillZona[y].SSID;
                            };
                            objeto.Status = 'AP';
                            objeto.IP = number;
                            arrComplete4.push(objeto);
                        }else{
                            const objeto = {};
                            objeto.Status = 'DISPONIBLE';
                            objeto.IP = number;
                            arrComplete4.push(objeto);
                        }
                    }
                }
                arrComp = arrComp.concat(arrComplete4);
                setArrIp(arrComp);
                setProcessRed(false);             
            });
        }else if(zonaSelectedObjectNew.ppoeList){
            fetch('/api/getIpsPPPoe',{
                method:'POST',
                body: JSON.stringify({InfoZona:zonaSelectedObjectNew}),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then((result) =>{
                let rangeZone = getRedNew.split('.');
                const arr4 = [];
                const arrComplete4 = [];
                for(const x in result){
                    for(const y in result[x]){
                        if(result[x][y].field === 'remote-address'){ 
                            let val = result[x][y].value.split('.');
                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2].toString()}.0`
                            if(getRedNew.toString() === range.toString()) arr4.push(result[x][y].value);
                        }
                    };
                };
                for(let i = 2; i < 255; i++ ){
                    let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                    if(arr4.includes(number)){
                        const objeto = {};
                        for(const x in result){
                            for(const y in result[x]){
                                if(result[x][y].field === 'remote-address'){ 
                                    if(result[x][y].value === number) {
                                        objeto.idFromMikrotik = result[x][0].value ; // idFromMikrotik
                                        objeto.idForMikrotik = result[x][1].value ; // username
                                        objeto.PassWord = result[x][4].value; // password
                                        objeto.Plan = result[x][5].value; // PLAN
                                        
                                    }
                                }
                            };
                        };
                        objeto.Status = 'NO DISPONIBLE';
                        objeto.IP = number;
                        arrComplete4.push(objeto);                                           
                    }else{
                        const objeto = {};
                        objeto.Status = 'DISPONIBLE';
                        objeto.IP = number;
                        arrComplete4.push(objeto);
                        
                    }
                }
                setArrIp(arrComplete4);         
                setProcessRed(false);                           
            });
        }else if(zonaSelectedObjectNew.sysintercom){
            fetch('/api/getIpsSimpleQueue',{
                method:'POST',
                body: JSON.stringify({InfoZona:zonaSelectedObjectNew}),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then((result) =>{
                let arrComp = [];
                for(const x in zonaSelectedObjectNew.Subnet){
                    let data = zonaSelectedObjectNew.Subnet[x];
                    let rangeZone = data.Red.split('.');
                    const arr4 = [];
                    const arrComplete4 = [];
                    for(const x in result){
                        for(const y in result[x]){
                            if(result[x][y].field === 'target'){ 
                                if(result[x][y].value.split('/').length === 2){
                                    let val_0 = result[x][y].value.split('/')[0].toString();
                                    let val = val_0.split('.');
                                    let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`
                                    if(data.Red.toString() === range.toString()) arr4.push(val_0);
                                }
                            }
                        };
                    };
                    for(let i = 2; i < 255; i++ ){
                        let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                        if(arr4.includes(number)){
                            const objeto = {};
                            for(const x in result){
                                for(const y in result[x]){
                                    if(result[x][y].field === 'target'){ 
                                        if(result[x][y].value.split('/').length === 2){
                                            let val_0 = result[x][y].value.split('/')[0].toString();
                                            if(val_0 === number) {
                                                objeto.idForMikrotik = result[x][1].value ;
                                                objeto.idFromMikrotikSimple = result[x][0].value ;
                                            }
                                        }

                                    }
                                };
                            };
                            objeto.Status = 'NO DISPONIBLE';
                            objeto.IP = number;
                            arrComplete4.push(objeto);                                           
                        }else{
                            const objeto = {};
                            objeto.Status = 'DISPONIBLE';
                            objeto.IP = number;
                            arrComplete4.push(objeto);
                        }
                    }
                    arrComp = arrComp.concat(arrComplete4);
                };
                fetch('/api/getIpsQueueTree',{
                    method:'POST',
                    body: JSON.stringify({InfoZona:zonaSelectedObjectNew}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(async (result2) =>{    
                    const jsonNew = await ConvertArrToJson(result2);
                    let arrComp2 = [];
                    for(const x in zonaSelectedObjectNew.Subnet){
                        let data = zonaSelectedObjectNew.Subnet[x];
                        let rangeZone = data.Red.split('.');
                        const arrComplete8 = [];
                        
                        const arr8 = jsonNew.filter(el=>{
                            let val = el.address?.split('.');
                            let range = `${val[0].toString()}.${val[1].toString()}.${val[2]?.toString()}.0`;
                            if(data.Red.toString() === range.toString()) return true;
                            else  return false;
                        }).map(el=>el.address).splice(1);

                        for(let i = 2; i < 255; i++ ){
                            let number = `${rangeZone[0].toString()}.${rangeZone[1].toString()}.${rangeZone[2].toString()}.${i}`;
                            if(arr8.includes(number)){
                                const findEl = jsonNew.find(el=> el.address === number);
                                const objeto = {};
                                objeto.idForMikrotik = findEl?.comment;
                                objeto.idFromMikrotik = findEl['.id'];
                                objeto.isActive = findEl.list ? findEl.list === 'Moroso' ? false : true : false ;
                                objeto.IP = number;
                                objeto.Status = 'NO DISPONIBLE';
                                arrComplete8.push(objeto);
                            }else{
                                const objeto = {};
                                objeto.Status = 'DISPONIBLE';
                                objeto.IP = number;
                                arrComplete8.push(objeto);
                            }
                        }
                        arrComp2 = arrComp2.concat(arrComplete8);
                    };
                    const arrNew_ = arrComp.map(el=>{
                        const objeto = {...el};
                        const arrF_ = arrComp2.find(el2=> el2.IP === el.IP);
                        objeto.idFromMikrotik = arrF_?.idFromMikrotik;
                        objeto.isActive = arrF_?.isActive;
                        return objeto;
                    })
                    setArrIp(arrNew_);
                    setProcessRed(false);  
                });        
            });
        }
    };

    const handleRedNew = (value)=>{ 
        setSelectRed(true);
        setContinuoRed(true);
        setRedNew(value);
    };

    const handleRedNewClear = ()=>{
        setSelectRed(false);
        setContinuoRed(false);
        setRedNew('');
    };

    const handleChangeZona = ()=>{
        if(getRedNew  === ''){ 
            enqueueSnackbar('SELECCIONE UNA SUBNET', {variant:'error'});
        }else if(getIpNew ===''){
            enqueueSnackbar('SELECCIONE UNA IP', {variant:'error'});
        }else if(selectPlanNew === ''){ 
            enqueueSnackbar('SELECCIONE UN PLAN', {variant:'error'});     
        }else if(isZonaPPOE && getDatos.UserPPOE === ''){ 
            enqueueSnackbar('INGRESE USUARIO PPOE', {variant:'error'});
        }else if(isZonaPPOE && getDatos.PassPPOE === ''){ 
            enqueueSnackbar('INGRESE PASS PPOE', {variant:'error'});
        }else{ 

            Swal.fire({
                title:'CAMBIO DE ZONA',
                text:'DESEA PROCEDER CON EL CAMBIO DE ZONA?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonColor:'#005596',
                width:500,
            }).then(result=>{
                if(result.isConfirmed){
                    const objetoZ = {...zonaSelectedObjectNew};
                    objetoZ.Planes = zonaSelectedObjectNew.planLocal ? zonaSelectedObjectNew.Planes : getPlanes ;
                    setStatus('active');
                    setSavingClient(true);
                    const objeto = {}
                    objeto.AddressIp = getIpNew;
                    objeto.InfoZona = objetoZ;
                    if(isOldIp){
                        setContinuo1(true); 
                    }else{
                        fetch('/api/clientes/ValidarIp',{
                            method:'POST',
                            body: JSON.stringify(objeto),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(resultB =>{
                            if(resultB.message){
                                setContinuo1(true); 
                                enqueueSnackbar('IP VALIDADA', {variant:'info'});
                            }else{
                                setStatus('exception');
                                Swal.fire({
                                    title:'PROBLEMA AL VALIDAR IP',
                                    icon:'error',
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonColor:'#005596',
                                    width:500,
                                    toast:true
                                });
                                setSavingClient(false);
                            }
                            
                        });
                    }

                    
                }
            })
        }
    };
    
    const handleDeleteServicio = ()=>{
            const objeto = {...data};
            objeto.idCliente = dataCliente._id
            objeto.InfoZona = zonaSelectedObject;
            fetch('/api/clientes/serviciosChangeZone',{
                method:'DELETE',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(resultB =>{
                if(resultB.message){                    
                    setContinuo2(true); 
                    enqueueSnackbar('SERVICIO ANTERIOR ELIMINADO', {variant:'info'});                      
                }else{
                    console.log(resultB);
                    setStatus('exception');
                    Swal.fire({
                        title:'PROBLEMA AL ELIMINAR SERVICIO',
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:500,
                        toast:true
                    });
                    setSavingClient(false);                   
                }
                
            })
        
    };

    const handleAddServicio = ()=>{
        const objetoZ = {...zonaSelectedObjectNew};
        objetoZ.Planes = zonaSelectedObjectNew.planLocal ? zonaSelectedObjectNew.Planes : getPlanes ;
        const objetoServ = {...data};
        objetoServ.ZonaService = zonaSelectedNew;
        objetoServ.Plan = selectPlanNew;
        objetoServ.PlanComercial = selectPlanNewComercial;
        objetoServ.ValPlan = valPlanNew;
        objetoServ.AddressIp = getIpNew;
        objetoServ.Red = getRedNew;
        objetoServ.UserPPOE = zonaSelectedObjectNew.ppoeList ? getDatos.UserPPOE : '';
        objetoServ.PassPPOE = zonaSelectedObjectNew.ppoeList ? getDatos.PassPPOE : '';
        objetoServ.TipoServicioMk = zonaSelectedObjectNew.simpleQueue ? 'simpleQueue' : zonaSelectedObjectNew.queueTree ? 'queueTree' : zonaSelectedObjectNew.ppoeList ? 'ppoeList' : 'sysintercom';
        objetoServ.FOptica = isNewFibraOptica ? true : false;
        objetoServ.TipoServicio = isNewFibraOptica ? 'Fibra Optica' : 'Radio Enlace';
        objetoServ.idCliente = dataCliente._id;
        objetoServ.Nombres = dataCliente.Nombres;
        objetoServ.InfoZona = objetoZ;
        objetoServ.isOldIp = isOldIp;
        objetoServ.idFromMikrotik = idOldIp;
        isNewFibraOptica && delete objetoServ.AP;
        isNewFibraOptica && delete objetoServ.Modelo;
        isNewFibraOptica && delete objetoServ.MacModelo;
        isNewFibraOptica && delete objetoServ.Router;
        isNewFibraOptica && delete objetoServ.MacRouter;
        isNewFibraOptica && delete objetoServ.UserMk;
        isNewFibraOptica && delete objetoServ.PassMk;
        isNewFibraOptica && delete objetoServ.RouterNSerie;
        !isNewFibraOptica && delete objetoServ.UserPPOE;
        !isNewFibraOptica && delete objetoServ.PassPPOE;
        
        fetch('/api/clientes/serviciosChangeZone',{
            method:'POST',
            body: JSON.stringify(objetoServ),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(resultB =>{
            if(resultB.message){ 
                setPorcentaje(100); 
                setStatus('success');   
                enqueueSnackbar('CLIENTE MIGRADO CON EXITO', {variant:'success'});   
                setSavingClient(false);                         
            }else{
                console.log(resultB);
                setStatus('exception');
                Swal.fire({
                    title:'PROBLEMA AL AGREGAR SERVICIO NUEVO',
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    width:500,
                    toast:true
                }).then((result)=>{
                    setSavingClient(false);                     
                });
                    
                
            }
            
        });    
    };

    const handleGenerarPass = ()=>{
        const passNew = GenerarPass();
        setDatos({...getDatos, PassPPOE:passNew });
    };

    const copyToClipBoardPass = ()=>{  
        copy(getDatos.PassPPOE) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleOldIp = (checked)=>{ setOldIp(checked); };

    return(
        <Paper style={{width:'95%', padding:10, margin:10, minHeight:isZonaPPOE ? 240 : 180}} square variant='outlined'>
            <Grid container spacing={2} justifyContent='center' alignItems='center'>
                <Grid item xs={9}>
                    <Autocomplete
                        id="ZonaNueva"
                        options={arrZonas.map(value=>value.Zona)}
                        value={zonaSelectedNew || ''}                              
                        renderInput={(params) => <TextField {...params} label="Zona Nueva" variant="outlined" size='small' fullWidth color='primary'/>}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearZonaNueva()
                            }else{
                                handleSelectZonaNueva(value);
                            }
                        }}  
                    />
                </Grid>
                <Grid item xs={3}>   
                    <TooltipAntd title="" color='BLUE' >
                        <SwitchAntd checkedChildren="IP VIEJA" unCheckedChildren="IP NUEVA" checked={isOldIp} onChange={handleOldIp} />
                    </TooltipAntd>                                             
                </Grid>
                
                { isSelectedZonaNew &&
                    <Grid item xs={12}>
                        <Grid container justifyContent='flex-start' spacing={2}>
                            <Grid item xs={isProcessRed ? 10 : 12}>
                                <Autocomplete
                                    id="Red"
                                    options={zonaSelectedObjectNew.Subnet.map(value=>value.Red)}
                                    value={getRedNew || ''}                              
                                    renderInput={(params) => <TextField {...params} label="Red Nueva" variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={(e,value, reason)=>{
                                        if(reason ===  'clear'){
                                            handleRedNewClear()
                                        }else{
                                            handleRedNew(value);
                                        }
                                    }}  
                                />
                            </Grid>
                            {
                                isProcessRed && 
                                <Grid item style={{margin:'0px auto', display:'flex', alignItems:'center'}}>
                                    <FacebookCircularProgress size={25}/>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                }
                
                <Grid item xs={12}>
                    <TextField 
                        id='AddressIp'
                        fullWidth
                        label='IP'
                        value={getIpNew || ''}
                        InputProps={{ startAdornment:<DnsIcon/> }}
                        onChange={handleAddressIp}
                        variant='outlined'
                        size='small'
                        margin='dense'
                        select
                        disabled={!isSelectRed}
                    >
                        {
                            getArrIp.map((el, index)=>{
                                if(el.Status === 'DISPONIBLE'){
                                    return(
                                        <MenuItem value={el.IP.toString()} style={{color:'green'}} key={`IP_Address_${index}`}>
                                            {el.IP.toString()}
                                        </MenuItem>
                                    )
                                }else{
                                    return(
                                        <MenuItem value={el.IP.toString()} style={{color:el.Status === 'NO DISPONIBLE' ? 'red': 'orange'}} key={`IP_Address_${index}`} >
                                            { `${el.IP.toString()} ${el.idForMikrotik === null ? '' : el.idForMikrotik}` }
                                        </MenuItem>
                                    )
                                }
                            })
                        }
                    </TextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField 
                        id='idForMikrotik'
                        fullWidth
                        label='idForMikrotik'
                        value={ data.idForMikrotik || ''}
                        variant='outlined'
                        size='small'
                        disabled={!isSelectedZona}
                        InputProps={{ 
                            endAdornment:
                            <IconButton size='small' onClick={copyToClipBoardUser} color='primary'>
                                <ContentCopyIcon/>
                            </IconButton>
                        }} 
                    />
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Autocomplete
                        id="PlanNuevo"
                        options={PlanesNew.map(value=>value.PlanComercial)}
                        value={selectPlanNew || ''}        
                        disabled={isOldIp}                      
                        renderInput={(params) => <TextField {...params} label="Plan Nuevo" variant="outlined" size='small' fullWidth color='primary' />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearPlanNew()
                            }else{
                                handleSelectPlanNew(value);
                            }
                        }}  
                    />
                </Grid>
                {
                    isZonaPPOE &&
                    <React.Fragment>
                        <Grid item sm={5} xs={12}>
                            <TextField 
                                id='UserPPOE'
                                fullWidth
                                label='UserPPOE'
                                value={getDatos.UserPPOE || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                disabled={!isSelectedZona || isOldIp}
                            />
                        </Grid>
                        <Grid item sm={7} xs={12}  >
                            <Grid container spacing={2}>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="GENERAR PASS" color='purple'>
                                        <ButtonAntd type="primary" icon={<LockOutlined />} size='large' onClick={handleGenerarPass}/>
                                    </TooltipAntd>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField 
                                        id='PassPPOE'
                                        fullWidth
                                        label='PassPPOE'
                                        value={getDatos.PassPPOE || ''}
                                        InputProps={{
                                            endAdornment:
                                            <IconButton size='small' onClick={copyToClipBoardPass} color='primary'>
                                                <ContentCopyIcon/>
                                            </IconButton>
                                        }}
                                        onChange={handleDatos}
                                        variant='outlined'
                                        size='small'
                                        
                                        disabled={!isSelectedZona || isOldIp}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                    
                }
                <Grid item  xs={12} style={{height:5}}>
                    {isSavingClient &&  <LinearProgress color='secondary' /> }
                </Grid>
                <Grid item xs={12}  >
                    <Grid container justifyContent='center'>
                        <Grid item>
                            <Progress percent={getPorcentaje} steps={3} status={getStatus} />
                        </Grid>
                    </Grid>
                    
                </Grid>
                <Grid item xs={5}>
                    <Button color='primary' onClick={handleChangeZona}  variant='contained' fullWidth size='large' disabled={getStatus === 'success' ? true : false}>
                        PROCEDER
                    </Button>
                </Grid>
            </Grid>
        </Paper>
       
    )

};

function CambiarZona({ 
    arrAps, 
    arrZonas, 
    data, 
    dataCliente,
    getPlanes,
    isSelectedZona, 
    zonaSelected, 
    zonaSelectedObject, 
}){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
            <CambiarZonaBack  
                arrAps={ arrAps }
                arrZonas={ arrZonas } 
                data={ data } 
                dataCliente={ dataCliente }
                getPlanes={ getPlanes }
                isSelectedZona={ isSelectedZona }
                zonaSelected={ zonaSelected }
                zonaSelectedObject={ zonaSelectedObject } 
            />
        </SnackbarProvider>
    );
};

export default CambiarZona;